import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled, thd, Grid, Col, Row } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';

import Clipsal from './images/FooterLogo-Clipsal@2x.png';
import Atom from './images/FooterLogo-Atom@2x.png';
import Trader from './images/FooterLogo-Trader@2x.png';

import { withSettings } from 'containers/WebApp/SettingsContext';

const FooterWrapper = styled.footer`
  background-image: linear-gradient(45deg, #ac385b 0, #1550a0 100%);
  color: white;

  &.login-footer {
    background-color: white;
    background-image: none;
    color: ${thd('text', '#161717')};

    li {
      border-right-color: ${thd('text', '#161717')};
      a {
        color: ${thd('text', '#161717')};
      }
    }
    ul.logos {
      li {
        padding-left: 40px;
        padding-right: 40px;
        ${up(
          'lg',
          css`
            border-right: 1px solid #b4b6b8;
          `
        )};

        div {
          padding: 0;
          height: 100px;
        }
        &:last-child {
          border-right: none;
        }
      }
    }
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 2rem 0 1rem 0;
  ${up(
    'sm',
    css`
      flex-direction: row;
      justify-content: space-between;
    `
  )};

  ul.logos {
    padding: 0.1rem 1rem;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;

    ${up(
      'sm',
      css`
        flex-direction: row;
      `
    )};

    li {
      text-align: center;
      border: 0;
      margin-bottom: 15px;
      div {
        background-color: white;
        width: 230px;
        border-radius: 9px;
        display: flex;
        align-items: center;
        padding: 20px;
        margin: 0 auto;
        ${up(
          'sm',
          css`
            height: 150px;
            width: auto;
          `
        )};
        img {
          width: 100%;
          height: auto;
          ${up(
            'sm',
            css`
              max-width: 220px;
              height: auto;
            `
          )};
        }
      }
    }
  }

  ul {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${up(
      'sm',
      css`
        flex-direction: row;
      `
    )};
  }

  li {
    font-size: 16px;
    text-align: center;
    ${up(
      'sm',
      css`
        border-right: 1px solid #fff;
        padding: inherit;
        text-align: left;
        border-right: 1px solid white;
        &:nth-last-child(1) {
          border-right: none;
        }
      `
    )};
    a {
      color: white;
      font-weight: normal;
      text-decoration: none;
      padding: 0.1rem 1rem;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const Footer = ({ defaultFooter }) => {
  const [isDefaultFooter, setIsDeefaultFooter] = useState('');

  useEffect(() => {
    setIsDeefaultFooter(defaultFooter);
  }, [defaultFooter]);

  return (
    <FooterWrapper className={isDefaultFooter ? '' : 'login-footer'}>
      <FooterContainer>
        <Grid justifyContent="center">
          <React.Fragment>
            <Row justifyContent="center">
              <Col xs={12}>
                <ul className="logos">
                  <li>
                    <div>
                      <img src={Clipsal} alt="Clipsal" />
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={Atom} alt="Atom" />
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={Trader} alt="Trader" />
                    </div>
                  </li>
                </ul>
              </Col>
            </Row>
          </React.Fragment>
          {/*<Row>
            <Col xs={12}>
              <ul>
                <li>
                  <Link to="/terms">Terms &amp; Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
                <li>
                  <Link to="/sitemap">Sitemap</Link>
                </li>
              </ul>
            </Col>
          </Row>*/}
          <Row>
            <Col xs={12}>
              <div className="text--center">
                <strong>
                  &copy; Rexel Online Advantage {new Date().getFullYear()}
                </strong>
              </div>
            </Col>
          </Row>
        </Grid>
      </FooterContainer>
    </FooterWrapper>
  );
};

Footer.propTypes = {
  defaultFooter: PropTypes.bool,
};

Footer.defaultProps = {
  defaultFooter: true,
};

export default withSettings(Footer);
